import i18n from '../../plugins/i18n';

const USE_CASES = {
  '2FA': {
    value: '2FA',
    label: 'campaigns.usecases.2FA',
  },
  CUSTOMER_CARE: {
    value: 'CUSTOMER_CARE',
    label: 'campaigns.usecases.CUSTOMER_CARE',
  },
  POLLING_VOTING: {
    value: 'POLLING_VOTING',
    label: 'campaigns.usecases.POLLING_VOTING',
  },
  HIGHER_EDUCATION: {
    value: 'HIGHER_EDUCATION',
    label: 'campaigns.usecases.HIGHER_EDUCATION',
  },
  PUBLIC_SERVICE_ANNOUNCEMENT: {
    value: 'PUBLIC_SERVICE_ANNOUNCEMENT',
    label: 'campaigns.usecases.PUBLIC_SERVICE_ANNOUNCEMENT',
  },
  MARKETING: {
    value: 'MARKETING',
    label: 'campaigns.usecases.MARKETING',
  },
  SECURITY_ALERT: {
    value: 'SECURITY_ALERT',
    label: 'campaigns.usecases.SECURITY_ALERT',
  },
  DELIVERY_NOTIFICATION: {
    value: 'DELIVERY_NOTIFICATION',
    label: 'campaigns.usecases.DELIVERY_NOTIFICATION',
  },
  ACCOUNT_NOTIFICATION: {
    value: 'ACCOUNT_NOTIFICATION',
    label: 'campaigns.usecases.ACCOUNT_NOTIFICATION',
  },
  FRAUD_ALERT: {
    value: 'FRAUD_ALERT',
    label: 'campaigns.usecases.FRAUD_ALERT',
  },
  MIXED: {
    value: 'MIXED',
    label: 'campaigns.usecases.MIXED',
  },
  LOW_VOLUME: {
    value: 'LOW_VOLUME',
    label: 'campaigns.usecases.LOW_VOLUME',
  },
};

const SPECIAL_USE_CASES = {
  CONVERSATIONAL: {
    value: 'CONVERSATIONAL',
    label: 'campaigns.usecases.CONVERSATIONAL',
  },
  CARRIER_EXEMPT: {
    value: 'CARRIER_EXEMPT',
    label: 'campaigns.usecases.CARRIER_EXEMPT',
  },
  SOCIAL: {
    value: 'SOCIAL',
    label: 'campaigns.usecases.SOCIAL',
  },
  CHARITY: {
    value: 'CHARITY',
    label: 'campaigns.usecases.CHARITY',
  },
  POLITICAL: {
    value: 'POLITICAL',
    label: 'campaigns.usecases.POLITICAL',
  },
  EMERGENCY: {
    value: 'EMERGENCY',
    label: 'campaigns.usecases.EMERGENCY',
  },
  SWEEPSTAKE: {
    value: 'SWEEPSTAKE',
    label: 'campaigns.usecases.SWEEPSTAKE',
  },
};

const USE_CASES_BUTTON_LABELS = {
  ONE: {
    label: i18n.tc('campaigns.usecaseButtonLabels.one'),
    value: 'ONE',
  },
  LOW_VOLUME: {
    label: i18n.tc('campaigns.usecaseButtonLabels.lowVolume'),
    value: 'LOW_VOLUME',
  },
  MIXED: {
    label: i18n.tc('campaigns.usecaseButtonLabels.mixed'),
    value: 'MIXED',
  },
};

const SUB_USE_CASES_MAX = 5;

const SUBUSE_CASES_MAX_AND_MIN = {
  MIXED: { max: SUB_USE_CASES_MAX, min: 2 },
  LOW_VOLUME: { max: SUB_USE_CASES_MAX, min: 1 },
  CARRIER_EXEMPT: { max: SUB_USE_CASES_MAX, min: 1 },
  CHARITY: { max: SUB_USE_CASES_MAX, min: 0 },
  CONVERSATIONAL: { max: SUB_USE_CASES_MAX, min: 0 },
  POLITICAL: { max: SUB_USE_CASES_MAX, min: 0 },
  SOCIAL: { max: SUB_USE_CASES_MAX, min: 0 },
};

const MAX_SAMPLE_CHARS = 1024;
const MAX_DESC_CHARS = 4096;
const MAX_NAME_CHARS = 50;

const NUMBER_LINKING_STATUS = {
  REJECTED: {
    value: 'REJECTED',
    label: 'rejected',
    connotation: 'warning',
  },
  APPROVED: {
    value: 'APPROVED',
    label: 'approved',
    connotation: 'success',
  },
  PENDING: {
    value: 'PENDING',
    label: 'pending',
    connotation: 'CTA',
  },
  WAITING_FOR_MIGRATION: {
    value: 'Waiting ',
    label: 'pending',
    connotation: 'CTA',
  },
  WAITING_FOR_VERIFIED_CAMPAIGN: {
    value: 'Waiting ',
    label: 'pending',
    connotation: 'CTA',
  },
  PROVIDER_UNKNOWN: {
    value: 'PROVIDER_UNKNOWN',
    label: 'pending',
    connotation: 'CTA',
  },
  PROVIDER_CANNOT_BE_DETERMINE: {
    value: 'PROVIDER_CANNOT_BE_DETERMINE',
    label: 'unknown number provider',
    connotation: 'CTA',
  }
};

const CAMPAIGN_QUALIFICATION_STATUS = {
  REJECTED: {
    value: 'REJECTED',
    label: 'rejected',
  },
  APPROVED: {
    value: 'APPROVED',
    label: 'approved',
  },
  REVIEW: {
    value: 'REVIEW',
    label: 'review',
  },
  SUSPENDED: {
    value: 'SUSPENDED',
    label: 'suspended',
  },
  UNKNOWN: {
    value: 'UNKNOWN',
    label: 'unknown',
  },
  UNLINKED: {
    value: 'UNLINKED',
    label: 'unlinked',
  }
};

const INITIAL_SETUP_FEE = 0;

export {
  USE_CASES,
  SPECIAL_USE_CASES,
  USE_CASES_BUTTON_LABELS,
  SUBUSE_CASES_MAX_AND_MIN,
  SUB_USE_CASES_MAX,
  MAX_SAMPLE_CHARS,
  MAX_DESC_CHARS,
  MAX_NAME_CHARS,
  NUMBER_LINKING_STATUS,
  INITIAL_SETUP_FEE,
  CAMPAIGN_QUALIFICATION_STATUS,
};
